module.exports = __webpack_public_path__ + "static/media/error.22389cf4.jpg";